import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const formatAED = (n) => {
  const num = Number(n || 0);
  return num.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const exportLedgerToPDF = (
  ledgerRows,
  startDate,
  endDate,
  broughtForwardBalance,
  totalIn,
  totalOut,
  closingBalance,
  accountName,
  selectedType = ""
) => {
  if (!ledgerRows || ledgerRows.length === 0) return;

  const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });

  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.text(selectedType ? "Ledger Report by Type" : "Ledger Report", 10, 12);

  doc.setFontSize(11);
  doc.setFont("helvetica", "normal");
  doc.text(`Report: ${accountName}`, 10, 20);
  doc.text(`Period: ${startDate} to ${endDate}`, 10, 26);
  if (selectedType) {
    doc.text("Type movement report: opening balance is not mixed with type filter.", 10, 32);
  } else {
    doc.text(`Balance B/F: ${formatAED(broughtForwardBalance)} AED`, 225, 20);
  }

  autoTable(doc, {
    startY: selectedType ? 38 : 32,
    margin: { left: 8, right: 8 },
    tableWidth: "auto",
    head: [["Date", "Account", "Type", "Description", "Amount In", "Amount Out", "Running Balance", "Paid By", "Comments"]],
    body: ledgerRows.map((r) => [
      r.isBFRow ? "-" : r.formattedDate,
      r.accountName || "-",
      r.expenseType || "-",
      r.description || "-",
      r.amountIn ? formatAED(r.amountIn) : "-",
      r.amountOut ? formatAED(r.amountOut) : "-",
      typeof r.runningBalance === "number" ? formatAED(r.runningBalance) : "-",
      r.paidBy || "-",
      r.comment || "-",
    ]),
    styles: { fontSize: 7.4, cellPadding: 1.1, lineColor: [180, 180, 180], lineWidth: 0.15, valign: "middle" },
    headStyles: { fillColor: [40, 116, 240], textColor: "#fff", fontSize: 8.2, fontStyle: "bold" },
    alternateRowStyles: { fillColor: [245, 245, 245] },
  });

  const finalY = doc.lastAutoTable.finalY + 6;
  doc.setFontSize(11);
  doc.setFont("helvetica", "normal");
  doc.text(`Total In:  ${formatAED(totalIn)} AED`, 10, finalY);
  doc.text(`Total Out: ${formatAED(totalOut)} AED`, 10, finalY + 6);
  doc.setFontSize(13);
  doc.setFont("helvetica", "bold");
  doc.text(`Closing Balance: ${formatAED(closingBalance)} AED`, 10, finalY + 15);

  const pageCount = doc.internal.getNumberOfPages();
  doc.setFontSize(9);
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.text(`Page ${i} of ${pageCount}`, doc.internal.pageSize.getWidth() / 2, doc.internal.pageSize.getHeight() - 8, { align: "center" });
  }

  const safeFileName = `${accountName} ${selectedType || "Ledger"} ${startDate} to ${endDate}.pdf`.replace(/[<>:"/\\|?*]+/g, "");
  doc.save(safeFileName);
};
